/*@ngInject*/
const OptionGroupController = function ($element, localization) {
    $element.addClass('optionGroup');

    this.booleanRadioButtonOptions = {};

    localization.getTranslations().then(function (translations) {
        this.booleanRadioButtonOptions[_.get(translations, 'optionGroup.booleanRadioButtons.true')] = 'true';
        this.booleanRadioButtonOptions[_.get(translations, 'optionGroup.booleanRadioButtons.false')] = 'false';

        this.getHeaderTitle = function () {
            return _.get(translations, this.headerTitleKey);
        };
    }.bind(this));
};

angular.module('ums.configuration')
    .controller('optionGroupController', OptionGroupController);
